import { useTranslation } from 'react-i18next';

export default function SocialProof() {
  const { t } = useTranslation();

  return (
    <section className="social-proof" style={{ padding: '60px 20px', textAlign: 'center', background: 'var(--bg)', borderTop: '0.5px solid var(--border)' }}>
      <p style={{ fontSize: '0.9rem', color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: '40px', fontWeight: '600' }}>
        {t('landing.socialproof.headline', { defaultValue: 'TRUSTED BY 10,000+ CREATORS, BRANDS, AND SOCIAL MEDIA MANAGERS' })}
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '40px', maxWidth: '1100px', margin: '0 auto' }}>
        {/* Benefícios rápidos */}
        <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '40px', color: 'var(--text)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ color: 'var(--gold)', fontSize: '1.2rem' }}>✓</span>
            <span style={{ fontWeight: '500' }}>{t('landing.socialproof.b1', { defaultValue: 'Saves up to 10 hours of writing/week' })}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ color: 'var(--gold)', fontSize: '1.2rem' }}>✓</span>
            <span style={{ fontWeight: '500' }}>{t('landing.socialproof.b2', { defaultValue: '2.4x higher average engagement' })}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ color: 'var(--gold)', fontSize: '1.2rem' }}>✓</span>
            <span style={{ fontWeight: '500' }}>{t('landing.socialproof.b3', { defaultValue: 'Professional copywriting, zero effort' })}</span>
          </div>
        </div>

        {/* Micro-Testimonials */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px', marginTop: '10px' }}>
          {[1, 2, 3].map((i) => (
            <div key={i} style={{ padding: '24px', background: 'var(--card-bg)', borderRadius: '16px', border: '1px solid var(--border)', textAlign: 'left', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <div>
                <div style={{ color: 'var(--gold)', marginBottom: '12px', fontSize: '0.9rem' }}>★★★★★</div>
                <p style={{ fontSize: '1rem', color: 'var(--text)', fontStyle: 'italic', marginBottom: '20px', lineHeight: '1.5' }}>
                  "{t(`landing.socialproof.t${i}_text`)}"
                </p>
              </div>
              <div>
                <strong style={{ fontSize: '0.9rem', color: 'var(--gold)', display: 'block' }}>
                  {t(`landing.socialproof.t${i}_author`)}
                </strong>
                <span style={{ fontSize: '0.8rem', color: 'var(--muted)' }}>{t('landing.socialproof.verified', { defaultValue: 'Verified User' })}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
